import { Accordion } from '../../../../../components/general/accordion';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { FinalCausalityRegisterHistoryProps } from './props';
import dayjs from 'dayjs';
import DateTimePickerField from '../../../../../components/general/fields/dateTimePickerField';
import { useFinalCausalityRegisterHistory } from './hook';

export const FinalCausalityRegisterHistory = ({
    finalCausality,
}: FinalCausalityRegisterHistoryProps) => {
    const { formik } = useFinalCausalityRegisterHistory(finalCausality);

    return (
        <Accordion
            title="REGISTRO"
            icon={<InsertInvitationIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Creado por"
                        name="createdBy"
                        size="small"
                        value={formik.values.createdBy}
                        onChange={console.log}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <DateTimePickerField
                        label="Fecha de creación"
                        name="createdAt"
                        size="small"
                        value={dayjs(finalCausality?.created_at).subtract(
                            5,
                            'h'
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Modificado por"
                        name="createdBy"
                        size="small"
                        value={formik.values.updatedBy}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <DateTimePickerField
                        label="Fecha de modificación"
                        name="createdAt"
                        size="small"
                        value={dayjs(finalCausality?.updated_at).subtract(
                            5,
                            'h'
                        )}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
